import React from "react";
import { Card } from "../../../components/ui/card";
import { Flame, Clock, Leaf, Star } from "lucide-react";
import { mockBenefits } from "../../../mock";
import useInViewOnce from "../useInViewOnce";

const iconMap = {
  Flame,
  Clock,
  Leaf,
  Star,
};

const BenefitsSection = () => {
  const [setRef, isInView] = useInViewOnce();

  return (
    <section id="keunggulan" className="mb-12 md:mb-16">
      <div
        ref={setRef}
        className={`${
          isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        } transition-all duration-300 ease-out`}
      >
        <header className="flex flex-col gap-1 mb-5 md:mb-6">
          <h2 className="text-lg font-semibold tracking-tight text-slate-900 md:text-xl">
            Kenapa Bumbu CINEURASA Beda?
          </h2>
          <p className="max-w-xl text-xs text-slate-600 md:text-sm">
            Bukan sekadar bumbu instan, tapi racikan rempah khas Aceh yang
            dibuat untuk kamu yang ingin masak cepat tanpa mengorbankan rasa.
          </p>
        </header>
        <div className="grid gap-4 md:grid-cols-4">
          {mockBenefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon] || Flame;

            return (
              <Card
                key={benefit.id}
                className="p-4 transition-all duration-300 ease-out border shadow-sm rounded-2xl border-border bg-card/80 hover:-translate-y-1 hover:shadow-lg"
                style={{
                  transitionDelay: isInView ? `${index * 80}ms` : "0ms",
                }}
              >
                {/* ICON */}
                <div className="flex items-center justify-center shadow-sm h-9 w-9 rounded-xl bg-primary text-primary-foreground">
                  <Icon className="w-4 h-4" />
                </div>

                {/* TITLE */}
                <h3 className="mt-3 text-sm font-semibold text-foreground">
                  {benefit.title}
                </h3>

                {/* DESCRIPTION */}
                <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">
                  {benefit.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
